@if (filterModel$ | async; as filterModel) {
  <div class="grid no-gutters">
    <div class="col-11">
      <p-checkbox
        label="{{ filterModel.filterDto.description }}: "
        [binary]="true"
        [ngModel]="true"
        [readonly]="filterModel.filterDto.readonly"
        class="readonly-filter-checkbox"
      >
      </p-checkbox>
      <a (click)="showNetworkSelector()"
        ><span style="padding-left: 5px; cursor: pointer"
          >Select Network(s)</span
        ></a
      >
    </div>
    <div [ngClass]="{ 'col-1': true }">
      <span
        class="pi pi-question-circle"
        [pTooltip]="filterModel.filterDto.help_text"
      ></span>
    </div>
  </div>
}
<p-dialog
  styleClass="networkDialog"
  [style]="{ width: '400px' }"
  header="Select network(s)"
  position="top"
  [(visible)]="networkSelectorVisible"
>
  <div class="pb-3">
    Click on a continent to unfold its list of networks.<br />
    You can find more information about the ISMN networks on the
    <a href="https://ismn.earth/en/networks/" target="_blank"
      >ISMN networks list</a
    >. <br />
    @if (networkFetchError()) {
      <div style="color: gray">
        {{ errorMessage }}
      </div>
    }
  </div>
  <p-tree
    [value]="networkTree"
    selectionMode="checkbox"
    (onNodeSelect)="onNetworkSelect($event)"
    (onNodeUnselect)="onNetworkUnselect($event)"
    [(selection)]="selectedNetworks"
  ></p-tree>
</p-dialog>
